export interface OperacaoInterface {
  operacaoInfo: OperacaoInfoInterface;
  materiais: MateriaisInterface[];
  arquivos: ArquivosInterface[];
  operacoes: OperacoesInterface[];
}

export interface OperacaoInfoInterface {
  codigoOrdemProducao: number;
  ordemProducao: number;
  numeroOs: number;
  codigoTipoOrdemProducao: number;
  tipoOrdemProducao: string;
  codigoEmpresa: number;
  codigoItem: number;
  codigoProduto: string;
  descricao: string;
  previsaoTermino: object;
  quantidadePlanejada: number;
  dataNecessidade: string;
  dataInicioOrdemProducao: string;
  numeroPedido: number;
  codigoPedido: number;
  codigoPedidoItem: number;
  observacao: string;
  statusOrdemProducao: number;
  ordem: number;
  codigoOperacao: number;
  operacao: string;
  codigoMaquinaExecucao: number;
  maquinaExecucao: string;
  quantidadeProduzida: number;
  dataInicioApontamento: string;
}

export interface MateriaisInterface {
  descricao: string;
  quantidade: number;
}

export interface ArquivosInterface {
  descricao: string;
  caminhoArquivo: string;
}

export interface OperacoesInterface {
  codigoOrdemProducao: number;
  codigoEmpresa: number;
  sequencia: number;
  operacao: string;
}

export class OperacaoInfo implements OperacaoInfoInterface {
  codigoOrdemProducao: number;
  ordemProducao: number;
  numeroOs: number;
  codigoTipoOrdemProducao: number;
  tipoOrdemProducao: string;
  codigoEmpresa: number;
  codigoItem: number;
  codigoProduto: string;
  descricao: string;
  previsaoTermino: object;
  quantidadePlanejada: number;
  dataNecessidade: string;
  dataInicioOrdemProducao: string;
  numeroPedido: number;
  codigoPedido: number;
  codigoPedidoItem: number;
  observacao: string;
  statusOrdemProducao: number;
  ordem: number;
  codigoOperacao: number;
  operacao: string;
  codigoMaquinaExecucao: number;
  maquinaExecucao: string;
  quantidadeProduzida: number;
  dataInicioApontamento: string;

  constructor() {
    this.codigoOrdemProducao = 0;
    this.ordemProducao = 0;
    this.numeroOs = 0;
    this.codigoTipoOrdemProducao = 0;
    this.tipoOrdemProducao = '';
    this.codigoEmpresa = 0;
    this.codigoItem = 0;
    this.codigoProduto = '';
    this.descricao = '';
    this.previsaoTermino = {};
    this.quantidadePlanejada = 0;
    this.dataNecessidade = '';
    this.dataInicioOrdemProducao = '';
    this.numeroPedido = 0;
    this.codigoPedido = 0;
    this.codigoPedidoItem = 0;
    this.observacao = '';
    this.statusOrdemProducao = 0;
    this.ordem = 0;
    this.codigoOperacao = 0;
    this.operacao = '';
    this.codigoMaquinaExecucao = 0;
    this.maquinaExecucao = '';
    this.quantidadeProduzida = 0;
    this.dataInicioApontamento = '';
  }
}

